export default "__VITE_ASSET__BHBvEJLc__"